import { render, staticRenderFns } from "./DocumentExplorer.vue?vue&type=template&id=e838f640&scoped=true"
import script from "./DocumentExplorer.vue?vue&type=script&lang=js"
export * from "./DocumentExplorer.vue?vue&type=script&lang=js"
import style0 from "./DocumentExplorer.vue?vue&type=style&index=0&id=e838f640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e838f640",
  null
  
)

export default component.exports